const current_url = window.location.pathname;

function dataStore() {
  if (current_url.includes('search')) {
    document.querySelectorAll('.product__item a').forEach(item => {
      item.addEventListener('click',function(e) {
        e.preventDefault();
        var productElement = item.parentNode.parentNode.parentNode.parentNode.parentNode;
        e.preventDefault();
        if (productElement.classList.contains('product__item')) {
          localStorage.setItem('lastViewedElement',`${window.location.href.split('&')[0]}?&page=${productElement.dataset.pagination}#${productElement.id}`);
          window.location=item.getAttribute('href');
        } else if(productElement.parentNode.parentNode.classList.contains('product__item')) {
          localStorage.setItem('lastViewedElement',`${window.location.href.split('?')[0]}?&page=${productElement.parentNode.parentNode.dataset.pagination}#${productElement.parentNode.parentNode.id}`);
          window.location=item.getAttribute('href');
        } else {
          window.location=item.getAttribute('href');
        }
      });
    });

  } else {
    document.querySelectorAll('.product__item a').forEach(item => {
      item.addEventListener('click',function(e) {
        e.preventDefault();
        var productElement = item.parentNode.parentNode;
        if (productElement.classList.contains('product__item')) {
          localStorage.setItem('lastViewedElement',`${window.location.href.split('?')[0]}?&page=${productElement.dataset.pagination}#${productElement.id}`);
          window.location=item.getAttribute('href');
        } else if(productElement.parentNode.parentNode.classList.contains('product__item')){
          localStorage.setItem('lastViewedElement',`${window.location.href.split('?')[0]}?&page=${productElement.parentNode.parentNode.dataset.pagination}#${productElement.parentNode.parentNode.id}`);
          window.location=item.getAttribute('href');
        } else {
          window.location=item.getAttribute('href');
        }
      });
    });
  }
}

dataStore();

function autoLoader() {
  const current_url = window.location.pathname;
  if (current_url.includes("collections") || current_url.includes("search")) {
    var products_on_page = document.getElementById("product-grid");
    var next_url = products_on_page.getAttribute("data-next-url");
    var loadprev_btn = document.querySelector(".load-prev-cstm-btn");
    var prev_url = products_on_page.getAttribute('data-prev-url');
    var loadmore_btn = document.querySelector(".load-more-cstm-btn");

    function loadMoreProducts() {
      fetch(next_url)
        .then((response) => {
          loadmore_btn.style.display = "none";
          return response.text();
        })
        .then((data) => {
          var parser = new DOMParser();
          var doc = parser.parseFromString(data, "text/html");
          var return_html = doc.body;
          var main_html = return_html.querySelector("#product-grid");
          var main_html_child = main_html.querySelectorAll(".grid__item");
          var new_url = main_html.getAttribute("data-next-url");
          if (new_url) {
            document.querySelector("#product-grid").setAttribute("data-next-url",main_html.getAttribute('data-next-url'))
            loadmore_btn.style.display = "none";
          }
          next_url = new_url;
          var mainProductWrapper = document.querySelector(".product-grid");
          setTimeout(() => {
          main_html_child.forEach(function (value, index) {
            document.querySelector(".product-grid").append(value);
          });

          document.querySelectorAll('.product__item a').forEach(item => {
            item.addEventListener('click',function(e) {
              e.preventDefault();
              var productElement = item.parentNode.parentNode.parentNode.parentNode;
              if (productElement.classList.contains('product__item')) {
                localStorage.setItem('lastViewedElement',`${window.location.href.split('?')[0]}?&page=${productElement.dataset.pagination}#${productElement.id}`);
                window.location=item.getAttribute('href');
              } else if (productElement.parentNode.parentNode.classList.contains('product__item')){
                localStorage.setItem('lastViewedElement',`${window.location.href.split('?')[0]}?&page=${productElement.parentNode.parentNode.dataset.pagination}#${productElement.parentNode.parentNode.id}`);
                window.location=item.getAttribute('href');
              } else {
                window.location=item.getAttribute('href');
              }
            })
          });

          var mainproductWrapper = document.querySelector('#product-grid');
            if(mainproductWrapper.classList.contains('grid__layout-2')
            || mainproductWrapper.classList.contains('grid__layout-4')
            || mainproductWrapper.classList.contains('layout__gallary-view')
            ){
              var featuredBannerImages = document.querySelectorAll('.featured__banner-image');
              featuredBannerImages.forEach(productImage => {
                const productImageSrc = productImage.getAttribute('data-productimage');
               productImage.src = productImageSrc;
              });
            }
            
            cardSlider();
            cardAtcBtn();
            variantListClose();
            dataStore();
            BackProduct();
            if (new_url) {
              loadmore_btn.style.display = "block";
            } else {
              loadmore_btn.style.display = "block";
              loadmore_btn.classList.add("ds-no-more-products-left");
              loadmore_btn.classList.add("ds-no-more-products-left");
              loadmore_btn.textContent="No more products";
            }
          }, 300);
        })
        .catch((err) => {
          console.log(err);
        });
    }

    function loadPreviousProducts() {

      if(prev_url){
        
      fetch(prev_url)
        .then((response) => {
          
          loadmore_btn.style.display = "none";
          return response.text();
        })
        .then((data) => {
          var parser = new DOMParser();
          var doc = parser.parseFromString(data, "text/html");
          var return_html = doc.body;
          var main_html = return_html.querySelector("#product-grid");

          var main_html_child = main_html.querySelectorAll(".grid__item");
          var new_url = main_html.getAttribute("data-prev-url");
          if (prev_url) {
            loadmore_btn.style.display = "none";
          }
          prev_url = new_url;
          var mainProductWrapper = document.querySelector(".product-grid");
          setTimeout(() => {
            for (var i = main_html_child.length - 1; i >= 0; i--) {
              document.querySelector(".product-grid").prepend(main_html_child[i]);
            }

            document.querySelectorAll('.product__item a').forEach(item => {
              item.addEventListener('click',function(e) {
                e.preventDefault();
                var productElement = item.parentNode.parentNode.parentNode.parentNode;
                if (productElement.classList.contains('product__item')) {
                  localStorage.setItem('lastViewedElement',`${window.location.href.split('?')[0]}?&page=${productElement.dataset.pagination}#${productElement.id}`);
                  window.location=item.getAttribute('href');
                } else if(productElement.parentNode.parentNode.classList.contains('product__item')){
                  localStorage.setItem('lastViewedElement',`${window.location.href.split('?')[0]}?&page=${productElement.parentNode.parentNode.dataset.pagination}#${productElement.parentNode.parentNode.id}`);
                  window.location=item.getAttribute('href');
                } else {
                  window.location=item.getAttribute('href');
                }
              });
            });

            var mainproductWrapper = document.querySelector('#product-grid');
            if(mainproductWrapper.classList.contains('grid__layout-2')
            || mainproductWrapper.classList.contains('grid__layout-4')
            || mainproductWrapper.classList.contains('layout__gallary-view')
            ){
              var featuredBannerImages = document.querySelectorAll('.featured__banner-image');
              featuredBannerImages.forEach(productImage =>{
              const productImageSrc = productImage.getAttribute('data-productimage');
              productImage.src = productImageSrc;
              })
            }

            cardSlider();
            cardAtcBtn();
            variantListClose();
            dataStore();
            BackProduct();

            if (prev_url) {
              loadmore_btn.style.display = "block";
            } else {
              products_on_page.setAttribute('data-prev-url','')
              document.querySelector('#product-grid').setAttribute('data-prev-url','');
              prev_url = '';
              loadmore_btn.style.display = "block";
              loadmore_btn.classList.add("ds-no-more-products-left");
              loadmore_btn.classList.add("ds-no-more-products-left");
            }
          }, 300);
        })
        .catch((err) => {
          console.log(err);
        });
      }
    }

    if (document.querySelectorAll("#load-more-cstm-btn").length > 0) {
      if (document.querySelector("#load-more-cstm-btn").classList.contains("ds-no-more-products-left")
      ) {
      } else {
        document.querySelector("#load-more-cstm-btn").addEventListener("click", () => {
          setTimeout(loadMoreProducts,0);
        });
      }
    }

    if (document.querySelectorAll('#load-prev-cstm-btn').length > 0) {
      document.querySelector('#load-prev-cstm-btn').addEventListener('click', ()=> {
        loadPreviousProducts();
      });
    }

    var btnClick = new Event("click");
    var loadprev_btn = document.querySelector(".load-prev-cstm-btn")
    document.addEventListener("scroll", function () {
      if(next_url){
        next_url = document.querySelector('#product-grid').getAttribute("data-next-url");
      }

      var collectionTplElm = document.querySelector(".collection_top-wrapper");
      var collectionTop = window.innerHeight;
      var collectionHeight = collectionTplElm.clientHeight;
      var posTop = collectionTop + collectionHeight - window.innerHeight;

      if (
        window.pageYOffset > posTop - 5000 &&
        window.pageYOffset < posTop + 5000
      ) {
        if (loadmore_btn) {
          if (loadmore_btn.classList.contains("btn-disabled")) {
          } else {
            loadmore_btn.dispatchEvent(btnClick);
            loadmore_btn.classList.add("btn-disabled");
            setTimeout(function () {
              if (loadmore_btn) {
                if (loadmore_btn.classList.contains("ds-no-more-products-left")) {
                } else {
                  loadmore_btn.classList.remove("btn-disabled");
                }
              }
            }, 1000);
          }
        }
      }
    });
  }
}

autoLoader();
